import { TextBtn } from "../text-btn";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { CalendarIcon } from "../../svg";
import { SelectInputWithoutForm } from "../select-input";
import { processServices } from "../../../services/InspectionOneServices";
import Skeleton from "react-loading-skeleton";

function GridFilterOptions({
  handleClose,
  siteConfigDetails,
  resetFilter,
  processFilterState,
  setProcessFilterState,
  setStartIndex,
}: any) {
  const { t } = useTranslation();
  const [logicAndSubProcess, setLogicAndSubProcess] = useState<any>([]);
  const [statusList, setStatusList] = useState<any>([]);
  const [inspectedByList, setInspectedByList] = useState<any>([]);
  const [screenMappingList, setScreenMappingList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [RangeDateValue, setRangeDateValue] = useState<
    [Date, Date] | undefined
  >(undefined);
  const [filterState, setFilterState] = useState(processFilterState);
  useEffect(() => { }, [processFilterState]);
  useEffect(() => {
    if (processFilterState.dateRange) {
      const { startDate, endDate } = processFilterState.dateRange;
      setRangeDateValue([new Date(startDate), new Date(endDate)]);
    }
    fetchProcessData();
  }, [processFilterState]);
  const filterSelectOptions =
    siteConfigDetails?.shiftsDetails?.map((shift: any) => ({
      label: shift.shiftType,
      value: shift.uniqueId,
    })) || [];

  const fetchProcessData = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const requestJson = { processLogicId: "" };
        const response: any = await processServices.GetLogicAndSubProcessV1(
          requestJson
        );
        if (response.success) {
          const data = response.data || {};

          if (data && data.responseResult) {
            const result = data.responseResult;
            const logicList = result.logicList || [];

            setLogicAndSubProcess(logicList);

            // Extract screen mappings from logicList sub components
            const screenMappings = logicList.flatMap((logic: any) => logic.subProcessLogicList || []);
            setScreenMappingList(screenMappings);

            setStatusList(result.statusList || []);
            setInspectedByList(result.inspectedByList || []);
          } else if (Array.isArray(data)) {
            setLogicAndSubProcess(data);
            const screenMappings = data.flatMap((logic: any) => logic.subProcessLogicList || []);
            setScreenMappingList(screenMappings);
            setStatusList([]);
            setInspectedByList([]);
          } else {
            const rawLogicList = data.logicList || [];
            setLogicAndSubProcess(rawLogicList);
            const screenMappings = rawLogicList.flatMap((logic: any) => logic.subProcessLogicList || []);
            setScreenMappingList(screenMappings);
            setStatusList(data.statusList || []);
            setInspectedByList(data.inspectedByList || []);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const updateFilterState = (key: string, value: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleDateChange = (newRange: any) => {
    setRangeDateValue(newRange);

    if (newRange && newRange.length >= 1) {
      let [startDate, endDate] = newRange;

      // Ensure startDate and endDate are valid Date objects
      startDate = new Date(startDate);
      endDate = endDate ? new Date(endDate) : startDate;

      if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
        // Convert to UTC format (No AM/PM)
        const utcStartDate = startDate.toISOString(); // "YYYY-MM-DDTHH:mm:ss.sssZ"
        const utcEndDate = endDate.toISOString();
        updateFilterState("dateRange", {
          startDate: utcStartDate,
          endDate: utcEndDate,
        });
      } else {
        console.error("Invalid date range selected");
        updateFilterState("dateRange", { startDate: "", endDate: "" });
      }
    } else {
      updateFilterState("dateRange", { startDate: "", endDate: "" });
    }
  };

  const handleShiftChange = (selectedUniqueId: any) => {
    if (selectedUniqueId?.value) {
      const selectedShift = siteConfigDetails.shiftsDetails.find(
        (shift: any) => shift.uniqueId === selectedUniqueId.value
      );
      if (selectedShift) {
        const { startTime, endTime } = selectedShift;
        updateFilterState("shift", {
          startTime,
          endTime,
          uniqueId: selectedUniqueId.value,
        });
      }
    }
  };

  const handleProcessInputChange = (name: string, value: any) => {
    updateFilterState(name, value);

    if (name === "processLogicId") {
      updateFilterState("subProcessLogicId", "");
    }
  };

  const handleFormSubmit = () => {
    setStartIndex(0);
    const updatedFilterState = {
      ...filterState,
      refresh: !filterState.refresh,
    };
    setFilterState(updatedFilterState); // Update local state
    setProcessFilterState(updatedFilterState); // Update parent state
    handleClose(); // Close the modal or popup
  };

  const handleCancel = () => {
    handleClose();
  };

  const parsedReportDetails = siteConfigDetails?.reportDetails && JSON.parse(siteConfigDetails.reportDetails);

  return (
    <div className="relative">
      <div className="w-[35rem] px-[2rem] py-[2rem] bg-io-white dark:bg-io-black-1a shadow-xl rounded-[0.6rem] ">

        {parsedReportDetails?.isProcessFilterEnabled===1 && (

          <>
            {parsedReportDetails?.processFilterDetails && parsedReportDetails?.processFilterDetails.includes("inspectedBy")
              &&

              <div className="w-full h-auto mb-10">
                {isLoading ? (
                  <Skeleton width="100%" height={47} borderRadius={3} />
                ) : (
                  <SelectInputWithoutForm
                    isSearchable={true}
                    labelName="Inspected By"
                    id="inspectedBy"
                    isRequired={false}
                    options={[{ label: "All", id: "" }, ...inspectedByList.map((item: any) => ({
                      label: item.name,
                      id: item.id
                    }))]}
                    defaultValue={
                      filterState.inspectedByUserUniqueId
                        ? {
                          label: inspectedByList.find((opt: any) => opt.id === filterState.inspectedByUserUniqueId)?.name,
                          id: filterState.inspectedByUserUniqueId,
                        }
                        : { label: "All", id: "" }
                    }
                    getOptionLabel={(option: any) => option.label}
                    getOptionValue={(option: any) => option.id}
                    getSelection={(option: any) =>
                      handleProcessInputChange("inspectedByUserUniqueId", option.id)
                    }
                  />
                )}
              </div>}

            <>
              {parsedReportDetails?.processFilterDetails && parsedReportDetails?.processFilterDetails.includes("logicName")
                &&
                <div className="w-full h-auto mb-10">
                  {isLoading ? (
                    <Skeleton width="100%" height={47} borderRadius={3} />
                  ) : (
                    <SelectInputWithoutForm
                      isSearchable={true}
                      labelName="Logic Name"
                      id="processLogic"
                      isRequired={false}
                      options={[{ label: "All", id: "" }, ...logicAndSubProcess.map((logic: any) => ({
                        label: logic.name,
                        id: logic.id,
                      }))]}
                      defaultValue={
                        filterState.processLogicId
                          ? {
                            label: logicAndSubProcess.find(
                              (logic: any) => logic.id === filterState.processLogicId
                            )?.name,
                            id: filterState.processLogicId,
                          }
                          : { label: "All", id: "" }
                      }
                      getOptionLabel={(option: any) => option.label}
                      getOptionValue={(option: any) => option.id}
                      getSelection={(option: any) =>
                        handleProcessInputChange("processLogicId", option.id)
                      }
                    />
                  )}
                </div>
              }
            </>
            {parsedReportDetails?.processFilterDetails && parsedReportDetails?.processFilterDetails.includes("screenMappingName")
              &&
              <div className="w-full h-auto mb-10">
                {isLoading ? (
                  <Skeleton width="100%" height={47} borderRadius={3} />
                ) : (
                  <SelectInputWithoutForm
                    isSearchable={true}
                    key={filterState.processLogicId}
                    labelName="Screen Mapping Name"
                    id="subProcessLogic"
                    isRequired={false}
                    options={[{ label: "All", id: "" }, ...
                      logicAndSubProcess
                        .find(
                          (logic: any) => logic.id === filterState.processLogicId
                        )
                        ?.subProcessLogicList.map((subLogic: any) => ({
                          label: subLogic.name,
                          id: subLogic.id,
                        })) || []
                    ]}
                    defaultValue={
                      filterState.subProcessLogicId
                        ? {
                          label: logicAndSubProcess
                            .find(
                              (logic: any) =>
                                logic.id === filterState.processLogicId
                            )
                            ?.subProcessLogicList.find(
                              (subLogic: any) =>
                                subLogic.id === filterState.subProcessLogicId
                            )?.name,
                          id: filterState.subProcessLogicId,
                        }
                        : { label: "All", id: "" }
                    }
                    getOptionLabel={(option: any) => option.label}
                    getOptionValue={(option: any) => option.id}
                    getSelection={(option: any) =>
                      handleProcessInputChange("subProcessLogicId", option.id)
                    }
                  />
                )}
              </div>}{" "}
            {parsedReportDetails?.processFilterDetails && parsedReportDetails?.processFilterDetails.includes("status")
              &&
              <div className="w-full h-auto mb-10">
                {isLoading ? (
                  <Skeleton width="100%" height={47} borderRadius={3} />
                ) : (
                  <SelectInputWithoutForm
                    isSearchable={true}
                    labelName="Status"
                    id="status"
                    isRequired={false}
                    options={[{ label: "All", id: "" }, ...statusList.map((item: any) => ({
                      label: item.name,
                      id: item.id
                    }))]}
                    defaultValue={
                      filterState.statusId
                        ? {
                          label: statusList.find((opt: any) => opt.id === filterState.statusId)?.name,
                          id: filterState.statusId,
                        }
                        : { label: "All", id: "" }
                    }
                    getOptionLabel={(option: any) => option.label}
                    getOptionValue={(option: any) => option.id}
                    getSelection={(option: any) =>
                      handleProcessInputChange("statusId", option.id)
                    }
                  />
                )}
              </div>}
          </>
        )}
        <div className="w-full h-auto mb-10 relative">
          {isLoading ? (
            <Skeleton width="100%" height={47} borderRadius={3} />
          ) :
            <DatePicker
              value={RangeDateValue}
              onChange={handleDateChange}
              range
              rangeHover
              dateSeparator=" to "
              portal
              inputClass="cus-date-range"
              format="YYYY-MM-DD HH:mm A"
              placeholder="Select Date Range"
              plugins={[
                <TimePicker
                  position="bottom"
                  format="hh:mm A"
                  hideSeconds={true}
                />,
              ]}
            />
          }
          {/* <div className="w-[2rem] h-auto absolute top-[50%] translate-y-[-50%] right-[5%] pointer-events-none">
            <CalendarIcon />
          </div> */}
        </div>

        {siteConfigDetails?.isShiftEnabled === 1 && (
          <div className="w-full h-auto mb-10">
            <SelectInputWithoutForm
              labelName={t("web.filter.label.shift")}
              id="getStartedUniqueId"
              isRequired={false}
              options={filterSelectOptions}
              defaultValue={
                filterSelectOptions.find(
                  (option: any) => option.value == filterState.shift.uniqueId
                ) || null
              }
              getOptionLabel={(option: any) => option.label}
              getOptionValue={(option: any) => option.value}
              getSelection={(selectedUniqueId: any) =>
                handleShiftChange(selectedUniqueId)
              }
            />
          </div>
        )}

        <div className="w-full h-auto flex justify-end items-center gap-4">
          <TextBtn
            label={t("web.common.button.cancel")}
            btnSize="small"
            btnStyle="fill-secondary"
            btnType="button"
            handleClick={handleCancel}
          />
          <TextBtn
            label={t("web.common.button.submit")}
            btnSize="small"
            btnStyle="fill-primary"
            btnType="submit"
            handleClick={handleFormSubmit}
          />
        </div>
      </div>
      <div className="absolute top-[-2rem] right-4 w-auto h-auto border-b-[1rem] border-b-io-white dark:border-b-io-black-1a border-t-[1rem] border-t-transparent border-s-[1rem] border-s-transparent border-e-[1rem] border-e-transparent shadow-2xl"></div>
    </div>
  );
}

export default GridFilterOptions;
